import { Directive, EventEmitter, input, Output } from '@angular/core';
import { debounceTime as debounceTimeRxjs, Subject, tap } from 'rxjs';

@Directive({
  standalone: true,
  selector: '[click.single],[click.double]',
  host: {
    '(click)': 'onClick($event)',
    '(dblclick)': 'onDblClick($event)',
  },
})
export class ClickDoubleDirective {
  readonly #click$ = new Subject<MouseEvent>();

  debounceTime = input(300);

  @Output('click.double') doubleClick = new EventEmitter();
  @Output('click.single') singleClick = new EventEmitter();

  constructor() {
    this.#click$
      .asObservable()
      .pipe(
        debounceTimeRxjs(this.debounceTime()),
        tap((event) => {
          event.stopPropagation();
          if (event.type === 'click') this.singleClick.emit(event);
          else this.doubleClick.emit(event);
        })
      )
      .subscribe();
  }

  onClick(event: MouseEvent) {
    event.stopPropagation();
    this.#click$.next(event);
  }

  onDblClick(event: MouseEvent) {
    event.stopPropagation();
    this.#click$.next(event);
  }
}
